import {
    FILE_UPLOAD_WRITE_MIMETYPE_INFO,
    INCOMING_DOCUMENT_CONVERSION_STATUS,
    RETRIEVED_ACTIVE_DOCUMENT_CONVERSION_STATUSES,
    ADD_UPLOAD_FAILED_DOCUMENT,
    DIMISS_FAILED_DOCUMENTS_ACCORDION,
} from 'common/actions/fileUploadActions';
import { composeReducers } from 'common/util/composeReducers';
import lodash from 'lodash';

export function writeMimeTypes(state, action){
    if(!action || action.type !== FILE_UPLOAD_WRITE_MIMETYPE_INFO){
        return state;
    }

    const {allowedMimeTypes, fileExtensionLookup} = action.payload;

    return {
        ...state,
        app: {
            ...state.app,
            allowedMimeTypes,
            fileExtensionLookup: JSON.parse(fileExtensionLookup)
        }
    };
}

export function incomingDocumentConversionStatus(state, action) {
    if(!action || action.type !== INCOMING_DOCUMENT_CONVERSION_STATUS){
        return state;
    }

    const {documentConversionStatus} = action.payload;
    const parsedStatus = JSON.parse(documentConversionStatus);
    const hasNewDocumentConversionResult = hasCompletedConversionStep(parsedStatus);
    const currentOnGoingConversionCount = lodash.get(state, 'documentConversionStatuses.onGoingConversionCount', 0);
    const onGoingConversionCount = hasCompletedConversionStep(parsedStatus) ? 
        currentOnGoingConversionCount - 1 : 
        currentOnGoingConversionCount + 1;

    return {
        ...state,
        documentConversionStatuses: {
            ...state.documentConversionStatuses,
            [parsedStatus.id]: parsedStatus,
            onGoingConversionCount
        },
        files: {
            ...state.files,
            hasNewDocumentConversionResult,
            lastUploadedDocument: parsedStatus
        }
    };
}

function hasCompletedConversionStep(documentStatus) {
    return documentStatus.status === 'success' || documentStatus.status === 'failed';
}

function getOngoingDocumentConversionCount(statuses) {
    return lodash.reduce(statuses, 
        (acc, documentStatus) => hasCompletedConversionStep(documentStatus) ? acc : acc + 1, 0);
}


export function activeDocumentConversions(state, action) {
    if(!action || action.type !== RETRIEVED_ACTIVE_DOCUMENT_CONVERSION_STATUSES){
        return state;
    }

    const {documentConversionStatuses} = action.payload;
    const parsedStatuses = JSON.parse(documentConversionStatuses);

    const statuses = lodash
        .chain(parsedStatuses)
        .map(status => JSON.parse(status))
        .keyBy('id')
        .value();

    return {
        ...state,
        documentConversionStatuses: {
            ...state.documentConversionStatuses,
            onGoingConversionCount: getOngoingDocumentConversionCount(statuses),
            ...statuses
        }
    };
}

export function addUploadFailedDocument(state, action) {
    if (!action || action.type !== ADD_UPLOAD_FAILED_DOCUMENT) {
        return state;
    }

    const { fileName } = action.payload;
    const documentsUploadFailedExisting = state.documentsUploadFailed || [];

    return {
        ...state,
        documentsUploadFailed: [...documentsUploadFailedExisting, {name: fileName}],
        dismissFailedDocumentsAccordion: false
    };
}

export function dismissFailedDocumentsAccordion(state, action) {
    if (!action || action.type !== DIMISS_FAILED_DOCUMENTS_ACCORDION) {
        return state;
    }

    return {
        ...state,
        documentsUploadFailed: [],
        dismissFailedDocumentsAccordion: true
    };
}

export default composeReducers(
    writeMimeTypes,
    incomingDocumentConversionStatus,
    activeDocumentConversions,
    addUploadFailedDocument,
    dismissFailedDocumentsAccordion
);